import { API_URI } from "../../helpers";

/**
 * Cliente de los endpoints de Meta Ads.
 *
 * El token va en localStorage y NO en una variable de entorno del build: este panel es un
 * build estático de CRA, así que cualquier REACT_APP_* queda escrito en el bundle público y
 * dejaría de ser un secreto. Se pide una vez por navegador y queda guardado.
 */
const CLAVE = "metaAdminToken";

export function getToken() {
  try {
    return localStorage.getItem(CLAVE) || "";
  } catch (e) {
    return "";
  }
}

export function setToken(v) {
  try {
    localStorage.setItem(CLAVE, v || "");
  } catch (e) {
    /* modo privado: se pierde al cerrar, no es crítico */
  }
}

async function pedir(metodo, ruta, cuerpo) {
  const res = await fetch(`${API_URI}/admin/meta${ruta}`, {
    method: metodo,
    headers: {
      "Content-Type": "application/json",
      "X-Meta-Admin-Token": getToken(),
    },
    body: cuerpo ? JSON.stringify(cuerpo) : undefined,
  });

  let datos = null;
  try {
    datos = await res.json();
  } catch (e) {
    datos = null;
  }

  if (!res.ok) {
    // 401 se distingue del resto: es "poné bien el token", no "algo se rompió".
    const err = new Error((datos && datos.error) || `Error ${res.status}`);
    err.status = res.status;
    err.datos = datos;
    throw err;
  }

  return datos;
}

export const api = {
  rendimiento: (dias) => pedir("GET", `/rendimiento?dias=${dias}`),
  // El detalle de una campaña va SIEMPRE con la ventana de la pantalla: mirar una campaña a
  // 7 días y la de al lado a 90 sin darse cuenta es la forma más fácil de concluir cualquier cosa.
  campana: (id, dias) => pedir("GET", `/campanas/${encodeURIComponent(id)}?dias=${dias}`),
  catalogo: (dias) => pedir("GET", `/catalogo?dias=${dias}`),
  intereses: (q) => pedir("GET", `/intereses?q=${encodeURIComponent(q)}`),
  publicaciones: (q) => pedir("GET", `/publicaciones?limite=60${q ? `&q=${encodeURIComponent(q)}` : ""}`),

  listarBorradores: (estado) => pedir("GET", `/borradores${estado ? `?estado=${estado}` : ""}`),
  verBorrador: (id) => pedir("GET", `/borradores/${id}`),
  crearBorrador: (cuerpo) => pedir("POST", "/borradores", cuerpo),
  generarBorrador: (cuerpo) => pedir("POST", "/borradores/generar", cuerpo),
  guardarBorrador: (id, cuerpo) => pedir("POST", `/borradores/${id}`, cuerpo),
  descartarBorrador: (id) => pedir("POST", `/borradores/${id}/descartar`),
  proponerBorrador: (id, cuerpo) => pedir("POST", `/borradores/${id}/proponer`, cuerpo),

  listarAcciones: (estado) => pedir("GET", `/acciones?estado=${estado || "proposed"}`),
  decidirAccion: (id, cuerpo) => pedir("POST", `/acciones/${id}/decidir`, cuerpo),
};
